export default __webpack_public_path__ + "static/media/bateria2bombo.cb278949.png";